import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Techstack() {
  return (
    <section className="techstack p-100 text_chat">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <h2 className="text-center">
              <span style={{ color: "#6D4FC1" }}>Tech Stack</span> Used
            </h2>
            <div className="tech_main_stack">
              <div className="tech_box_stack">
                <div className="tech_img_stack">
                  <StaticImage
                    src="../../../images/case-studies/nurse-practition/mobile_arc.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={364}
                    height={112}
                  />
                </div>
                <div className="tech_img_head">
                  <h5>Mobile Architecture</h5>
                  <p>Android, iOS, MySQL</p>
                </div>
              </div>
              <div className="tech_box_stack">
                <div className="tech_img_stack">
                  <StaticImage
                    src="../../../images/case-studies/nurse-practition/web_arc.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={308}
                    height={112}
                  />
                </div>
                <div className="tech_img_head">
                  <h5>Web Architecture</h5>
                  <p>PHP, MySQL</p>
                </div>
              </div>
              <div className="tech_box_stack">
                <div className="tech_img_stack">
                  <StaticImage
                    src="../../../images/case-studies/nurse-practition/tools.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={112}
                    height={112}
                  />
                </div>
                <div className="tech_img_head">
                  <h5>Tools and testing </h5>
                  <p>VS Code, Stripe </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Techstack;
